import React, { Fragment } from 'react';
import classNames from 'classnames';

import MobileHeader from './mobile_header/mobile_header.jsx';
import DesktopHeader from './desktop_header/desktop-header_container.js';

import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const HeaderWrapperUi_ViewerVersion1 = ({ ...props }) => (
  <div {...props} />
);

const HeaderWrapperUi_ViewerVersion2 = ({ ...props }) => (
  <header {...props} />
);

const HeaderWrapperUi = (props) => (
  <SiteViewerVersionComponentSelector>
    <HeaderWrapperUi_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <HeaderWrapperUi_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

const Header = ({
  renderAsMobile = false,
  shouldShowHeaderContents,
  children,
}) => {
  return (
    <Fragment>
      {shouldShowHeaderContents && (
        <HeaderWrapperUi
          className={classNames({
            header: !renderAsMobile,
          })}
        >
          {renderAsMobile ? <MobileHeader /> : <DesktopHeader />}
          {children}
        </HeaderWrapperUi>
      )}
    </Fragment>
  );
};

export default Header;